var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 39794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 12334"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 643",
    opacity: 0.05,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#2DB0D8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.125 27.8333C19.4774 27.8333 18.8583 27.5721 17.621 27.0496C14.5406 25.7481 13 25.0965 13 24.0017V15.9583M20.125 27.8333C20.7726 27.8333 21.3917 27.5721 22.629 27.0496C25.7094 25.7481 27.25 25.0965 27.25 24.0017V15.9583M20.125 27.8333V19.406M15.375 19.9167L16.9583 20.7083M24.0833 13.5833L16.1667 17.5417M17.2164 18.0887L14.904 16.9701C13.6349 16.3557 13 16.0486 13 15.5625C13 15.0764 13.6349 14.7692 14.904 14.1549L17.2156 13.0363C18.6446 12.3452 19.3571 12 20.125 12C20.8929 12 21.6062 12.3452 23.0336 13.0363L25.346 14.1549C26.6151 14.7692 27.25 15.0764 27.25 15.5625C27.25 16.0486 26.6151 16.3557 25.346 16.9701L23.0344 18.0887C21.6054 18.7798 20.8929 19.125 20.125 19.125C19.3571 19.125 18.6438 18.7798 17.2164 18.0887Z",
    stroke: "#2DB0D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeIcon);
export default __webpack_public_path__ + "static/media/subscribe-icon.b9d7ff3551bba9caa4ae8a53c01347cb.svg";
export { ForwardRef as ReactComponent };